import React from 'react';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {FILE_UPLOAD_ERRORS} from './constants';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';

const ERRORS_ID = Object.keys(FILE_UPLOAD_ERRORS).map(
  // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly SIZE: { readonly id: "SIZE_ERROR"; readonly msg: "Upload failed. Max size for files is 10 MB."; readonly path: readonly ["data", "form", "SIZE_ERROR"]; }; readonly TYPE: { readonly id: "TYPE_ERROR"; readonly msg: "Upload failed. Invalid file type."; readonly path: readonly [...]; }; readonly GENERIC: { .....'.
  (err) => FILE_UPLOAD_ERRORS[err].id
);

const FormFileUploadErrorMsg = Atom.createRender(
  ({attributes, classes, generateAttributes, data}) => {
    const updatedClasses = classes.push('w-file-upload-error-msg');

    const errorsMsg = ERRORS_ID.reduce<Record<string, any>>((acc, errId) => {
      // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
      const msg = data?.form?.[errId] ?? 'Upload failed.';
      acc[errId] = msg;
      return acc;
    }, {});

    // @ts-expect-error - TS18046 - 'data' is of type 'unknown'
    const tempErrorId = data?.temp?.state ?? ERRORS_ID[0];
    const message = errorsMsg[tempErrorId];

    const errorsAttr = {
      'data-w-size-error': errorsMsg[FILE_UPLOAD_ERRORS.SIZE.id],
      'data-w-type-error': errorsMsg[FILE_UPLOAD_ERRORS.TYPE.id],
      'data-w-generic-error': errorsMsg[FILE_UPLOAD_ERRORS.GENERIC.id],
    } as const;

    return (
      <div {...generateAttributes(attributes, updatedClasses)} {...errorsAttr}>
        {message}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Error Message',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Text')),
  },
  showEmpty: false,
  render: FormFileUploadErrorMsg,
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Form'), typeName('FormFileUploadErrorMsg'))
  ),
});

export default config;
